module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst parts = []\nconst fieldConfig = model.config || {}\nif(attributes.startTS){\nparts.push(utils.moment(attributes.startTS).format(fieldConfig.startFormat || 'DD.MM.YYYY HH:mm'))\n}\nif(attributes.endTS){\nparts.push(`- ${utils.moment(attributes.endTS).format(fieldConfig.endFormat || 'HH:mm')}`)\n}\nif(parts.length < 1){\nparts.push('-')\n}\n%><div><%\n%><%= parts.join(' ') %><%\n%></div>"
  , __filename = "components/templates/core/table/fields/timeRange.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const parts = []
const fieldConfig = model.config || {}
if(attributes.startTS){
parts.push(utils.moment(attributes.startTS).format(fieldConfig.startFormat || 'DD.MM.YYYY HH:mm'))
}
if(attributes.endTS){
parts.push(`- ${utils.moment(attributes.endTS).format(fieldConfig.endFormat || 'HH:mm')}`)
}
if(parts.length < 1){
parts.push('-')
}

    ; __line = 15
    ; __append("<div>")
    ; 

    ; __line = 16
    ; __append(escapeFn( parts.join(' ') ))
    ; 

    ; __line = 17
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/table/fields/timeRange.ejs

}